import { t } from '@lingui/core/macro';
import { EmptyState, Loader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { DocumentPreviewPdf } from './DocumentPreviewPdf';
import { SidebarSectionError } from '../../components/SidebarSectionError';
import { Container, DocumentHtml, PdfContainer, StateContainer } from './styled';
export function DocumentPreviewContent(props) {
    const { document, html, renderAsPdf, loading, error } = props;
    if (loading) {
        return (<StateContainer>
        <Loader />
      </StateContainer>);
    }
    if (error) {
        return (<StateContainer>
        <SidebarSectionError />
      </StateContainer>);
    }
    if (renderAsPdf && document) {
        return (<PdfContainer>
        <DocumentPreviewPdf key={document.id} document={document}/>
      </PdfContainer>);
    }
    if (!html) {
        return (<StateContainer>
        <EmptyState icon={<Falcon icon="eye-slash"/>} title={t({
                message: 'No preview available',
                comment: 'Document preview sidebar - Empty state title',
            })} description={t({
                message: 'We do not currently support previewing documents of this file type.',
                comment: 'Document preview sidebar - Empty state description',
            })}/>
      </StateContainer>);
    }
    return (<Container>
      {/* eslint-disable-next-line react/no-danger */}
      <DocumentHtml className="ck-content" dangerouslySetInnerHTML={{ __html: html }}/>
    </Container>);
}
